require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./recipes-dahike-angare.json") })
        }
      }, "path---recipes-dahike-angare");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---recipes-dahike-angare!./.cache/json/recipes-dahike-angare.json
// module id = 730
// module chunks = 231608221292675